import React from "react";
import { Button, ButtonProps, CircularProgress } from "@mui/material";
import { colorVariables } from "../../utils/colorVariable";

interface CustomBottomProps extends ButtonProps {
  loading?: boolean;
  text: string;
  bgcolor?: string;
  background?: string;
  customColor?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  width?: any;
  height?: any;
  isHide?: boolean;
}

const CustomButton: React.FC<CustomBottomProps> = ({
  loading,
  text,
  startIcon,
  customColor,
  endIcon,
  variant,
  bgcolor,
  disabled,
  width,
  background,
  isHide,
  height,
  ...props
}) => {
  return (
    <Button
      variant={variant ?? "contained"}
      disabled={loading || disabled}
      startIcon={!loading ? startIcon : null}
      endIcon={!loading ? endIcon : null}
      {...props}
      size="small"
      sx={{
        display: isHide ? "none" : "",
        width: width,
        height: height,
        textTransform: "none",
        bgcolor: bgcolor ?? colorVariables.primary,
        color: customColor ?? colorVariables.white,
        background: !disabled && !loading ? background : "",
        padding: 1,
        "&:disabled": {
          backgroundColor: colorVariables.gray,
          color: colorVariables.disabledColor,
          opacity: colorVariables.disabledOpacity,
        },
        ...props.sx,
      }}
    >
      {loading ? <CircularProgress size={24} /> : text}
    </Button>
  );
};

export default CustomButton;
